import gql from 'graphql-tag';
import { PromotionBasicFields } from './fragments/Promotion';

const key = `UpdatePromotion`;

const mutation = gql`
${PromotionBasicFields}
mutation ${key}($input:UpdatePromotionInput!) {
  updatePromotion(input: $input) {
    ...PromotionBasicFields
  }
}
`;

export const UPDATE_PROMOTION = { key, mutation };
